<template>
  <el-form label-position="top" style="width: 100%">
    <slot name="admin-extension"></slot>
    <el-row :gutter="30">
      <el-col :xs="24" :md="8">
        <TimeSearch
            :full-width-select="true"
            ref="timeSearch"
            :month="true"
            :show-last-month="true"
        />
      </el-col>
      <el-col :xs="24" :md="8">
        <el-form-item label="Страна">
          <CountrySelect v-model="selectedCountry" ref="countrySelect" :full-width="true"/>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8">
        <el-form-item label="Канал">
          <el-select v-model="reportProduct" style="width: 100%">
            <el-option label="Все" value=""></el-option>
            <el-option v-for="(label, type) in $CHANNEL_NAMES" :label="label" :value="type"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="30" justify="start">
      <el-col :xs="24" :md="8">
        <el-form-item label="Группировать по">
          <el-select v-model="grouping" class="full-width">
            <el-option label="Группам операторов" :value="0"></el-option>
            <el-option label="Операторам" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" v-show="grouping === 0">
        <el-form-item label="Группа операторов">
          <el-select v-model="operatorGroup" style="width: 100%" :filterable="true">
            <el-option label="Все группы" value=""></el-option>
            <el-option
                v-for="(v, i) in $store.getters.operatorsGroupsSms"
                :key="i"
                :label="v.title"
                :value="v._id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :md="8" v-show="grouping === 1">
        <el-form-item label="Оператор">
          <el-select v-model="operator" style="width: 100%;" :filterable="true">
            <el-option label="Все операторы" value=""></el-option>
            <el-option
                v-for="(v, i) in operators"
                :key="i"
                :label="v.label"
                :value="v.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :md="8">
        <el-form-item label="Тип отчета">
          <el-select v-model="reportType" style="width: 100%">
            <el-option label="Общий" value="simple"></el-option>
            <el-option label="Подробный" value="detailed"></el-option>
            <el-option label="По пользователям" value="byUsers"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-button type="success" plain @click="getReport" :loading="reportLoading" :disabled="reportButtonDisabled">Применить</el-button>
  <el-button type="primary" plain @click="downloadReport" v-show="reportReady && reportTypeStatic !== 'simple'"
              :loading="reportDownloading">Экспортировать
  </el-button>

  <div v-show="reportReady" style="margin-top: 50px">

    <h3 class="no-margin-top"
        style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap">
      <span>Детализация за {{ detailHeaderMonth }}</span>
      <el-checkbox-group v-model="unwrapBy" v-show="reportTypeStatic !== 'simple'">
        <el-checkbox label="countryName">Страна</el-checkbox>
        <el-checkbox label="type">Канал</el-checkbox>
        <el-checkbox label="trafficType">Тип трафика</el-checkbox>
        <el-checkbox label="senderName">Подпись</el-checkbox>
        <el-checkbox label="operatorName">Оператор</el-checkbox>
      </el-checkbox-group>
    </h3>

    <!-- GENERAL REPORT TABLE -->
    <GeneralReportTable v-if="visibleReportType === 'simple'" :table-data="commonReportTableData" />


    <!-- DETAIL REPORT TABLE -->
    <div v-if="visibleReportType !== 'simple'">
      <FinDetailUserSmsTable
          v-if="visibleReportType === 'detailed' && !this.reportLoading"
          :table-data="detailReportTableDataUnwrapped"
          :grouping="groupingStatic"
          :unwrapBy="unwrapBy"
      />
      <el-tabs v-model="visibleUserId" class="inside-tabs"
                v-if="visibleReportType === 'byUsers'  && !this.reportLoading"
                v-show="Object.keys(detailReportTableData).length"
      >
        <el-tab-pane
            v-for="(tableData, userId, index) in detailReportTableDataUnwrapped"
            :key="userId + '_' + index"
            :label="userId" :name="userId"
        >
          <FinDetailUserSmsTable
              :table-data="tableData"
              :omit-first-separator="true"
              :grouping="groupingStatic"
              :unwrapBy="unwrapBy"
          />
        </el-tab-pane>
      </el-tabs>
      <NamesDetailedReportTable :table-data="detailReportNamesTableData" :general-statistics="generalStatistics" />
      <GlobalSummaryDetailedReportTable :table-data="detailReportGlobalSummaryRows" />
    </div>
  </div>
</template>

<script>
import iconv from "iconv-lite";
import TimeSearch from "@shared/components/reports/time-search.component"
import CountrySelect from "@shared/components/country-select.component"

import GeneralReportTable from "./tables/general-report-table-component"
import FinDetailUserSmsTable from "./tables/findetail-user-sms-table.component"
import NamesDetailedReportTable from "./tables/names-detailed-report-table.component"
import GlobalSummaryDetailedReportTable from "./tables/global-summary-detailed-report-table.component"

export default {
  name: "FinancialOperationsReport",
  components: {
    FinDetailUserSmsTable,
    GeneralReportTable,
    NamesDetailedReportTable,
    GlobalSummaryDetailedReportTable,

    TimeSearch,
    CountrySelect
  },
  props: {
    getReportUrl: String,
    mutateParams: {
      type: Function,
      default: p => p
    },
    reportButtonDisabled: {
      type: Boolean,
      default: false
    }
  },
  async mounted() {
    let resp = await this.axios.get("/resources/operators")
    this.operators = resp.data.map(c => {
      return {label: c.OrgName, value: c._id, mcc: Number(c.mcc), mnc: c.MNC, OrgName: c.OrgName}
    })
  },
  computed: {
    detailReportTableDataUnwrapped() {
      let unwrapRateLevel = tableData => {
        return Object.entries(tableData).reduce((acc, [rateName, rows]) => {
          acc[rateName] = Object.values(rows.reduce((acc, r) => {
            let key = this.unwrapBy.map(k => r[k]).join("_")
            if (!acc[key]) {
              acc[key] = Object.assign({}, r)
              acc[key].sent = 0
              acc[key].spent = 0
              acc[key].avgPrice = []
              acc[key].__precision = []
            }
            acc[key].sent += r.sent
            acc[key].spent += r.spent
            acc[key].avgPrice.push(r.avgPrice)
            acc[key].__precision.push(r.__precision)
            return acc
          }, {})).sort((r1, r2) => r1.senderName.localeCompare(r2.senderName)).map(v => {
            v.__precision = Math.max(...v.__precision) || 2
            v.avgPrice = this.reduceAvg(v.avgPrice)
            return v
          })
          return acc
        }, {})
      }

      if (this.reportTypeStatic === "detailed") return this.deduplicateDetailRows(unwrapRateLevel(this.detailReportTableData))
      if (this.reportTypeStatic === "byUsers") return Object.entries(this.detailReportTableData).reduce((acc, [userId, rateLevelData]) => {
        acc[userId] = this.deduplicateDetailRows(unwrapRateLevel(rateLevelData))
        return acc
      }, {})
      return {}
    }
  },
  methods: {
    groupResultRowsByUser(sms, retval, names, license, templates, prepaidPacks) {
      let groupedNames = {}
      let groupedTemplates = {}
      let groupedLicense = {}
      let groupedSms = {}
      let groupedPrepaidPackages = {}


      for (let row of sms) {
        if (!groupedSms[row.target]) groupedSms[row.target] = {byRates: {}, retval: {}}
        if (!groupedSms[row.target].byRates[row.rate_name]) groupedSms[row.target].byRates[row.rate_name] = []
        groupedSms[row.target].byRates[row.rate_name].push(row)
      }

      for (let row of retval) {
        if (!groupedSms[row.target]) groupedSms[row.target] = {byRates: {}, retval: {}}
        if (!groupedSms[row.target].retval[row.rate_name]) groupedSms[row.target].retval[row.rate_name] = []
        groupedSms[row.target].retval[row.rate_name].push(row)
      }

      for (let row of names) {
        if (!groupedSms[row.target]) groupedSms[row.target] = {byRates: {}}
        if (!groupedNames[row.target]) groupedNames[row.target] = {byRates: {}}
        if (!groupedLicense[row.target]) groupedLicense[row.target] = {byRates: {}}
        if (!groupedNames[row.target].byRates[row.rate_name]) groupedNames[row.target].byRates[row.rate_name] = []
        groupedNames[row.target].byRates[row.rate_name].push(row)
      }
      for (let row of license) {
        if (!groupedSms[row.target]) groupedSms[row.target] = {byRates: {}}
        if (!groupedNames[row.target]) groupedNames[row.target] = {byRates: {}}
        if (!groupedLicense[row.target]) groupedLicense[row.target] = 0

        groupedLicense[row.target] += Number(row.totalSum)
      }
      for (let row of templates) {
        if (!groupedTemplates[row.target]) groupedTemplates[row.target] = {byOperator: {}}
        if (!groupedTemplates[row.target].byOperator[row.operator_group_id]) groupedTemplates[row.target].byOperator[row.operator_group_id] = []
        groupedTemplates[row.target].byOperator[row.operator_group_id].push(row)
      }
      for (let row of prepaidPacks) {
        if (!groupedPrepaidPackages[row.target]) groupedPrepaidPackages[row.target] = {byOperator: {}}
        if (!groupedPrepaidPackages[row.target].byOperator[row.operator_group_id]) groupedPrepaidPackages[row.target].byOperator[row.operator_group_id] = []
        groupedPrepaidPackages[row.target].byOperator[row.operator_group_id].push(row)
      }
      return {groupedSms, groupedNames, groupedLicense, groupedTemplates, groupedPrepaidPackages}
    },
    deduplicateDetailRows(rows) {
      return Object.entries(rows).reduce((mAcc, [rateName, rateRows]) => {
        mAcc[rateName] = Object.values(rateRows.reduce((acc, r) => {
          let key = `${r.countryName}_${r.type}_${r.trafficType}_${r.senderName}_${r.operatorName}_${r.avgPrice}`
          if (!acc[key]) {
            acc[key] = Object.assign({}, r)
            acc[key].sent = 0
            acc[key].spent = 0
          }
          acc[key].sent += r.sent
          acc[key].spent += r.spent
          acc[key].__precision = Math.max(acc[key].__precision, r.__precision)
          return acc
        }, {}))
        return mAcc
      }, {})
    },
    generateReportData(groupedResult, __report_type) {
      let {groupedSms, groupedNames, groupedLicense, groupedTemplates, groupedPrepaidPackages} = groupedResult
      let generalStatistics = {
        call: {
          sent: 0,
          spent: 0,
        },
        sms: {
          sent: 0,
          spent: 0
        },
        vk: {
          sent: 0,
          spent: 0
        },
        telegram: {
          sent: 0,
          spent: 0
        },
        push: {
          sent: 0,
          spent: 0
        },

        avgPrice: 0,
        names: {
          records: [],
          spent: 0,
          avgPrice: 0,
          totalNames: 0
        },
        templates: {
          spent: 0,
          avgPrice: 0,
          totalTemplates: 0,
        },
        prepaidPacks: {
          spent: 0,
          avgPrice: 0,
          totalPacks: 0,
        },
        license: {
          total: Object.values(groupedLicense).reduce((acc, v) => acc + v, 0)
        }
      }
      let totalRecords = 0

      this.detailReportGlobalSummaryRows = [
        {amount: 0, spent: 0, name: 'Сообщения и звонки'},
        {amount: 0, spent: 0, name: 'Подписи'},
        {amount: 0, spent: 0, name: 'Шаблоны СМС'},
        {amount: 0, spent: 0, name: 'Предоплаченные пакеты СМС'},
        {amount: 0, spent: 0, name: 'Лицензионные списания'},
      ]
      let detailData = {}
      for (let [userId, userData] of Object.entries(groupedSms)) {
        detailData[userId] = {}
        for (let [rateName, rateData] of Object.entries(userData.byRates)) {
          if (!detailData[userId][rateName]) detailData[userId][rateName] = []
          let retvalData = userData.retval[rateName] || []

          let addedOpsForThisRate = 0
          for (let record of rateData) {
            let retval = retvalData.find(r => record.operator_group_id === r.operator_group_id && record.sms_type === r.sms_type) || {
              totalSum: 0,
              totalMessages: 0
            }

            record.operator = this.operators.find(o => o.value === record.operator_id) || {
              OrgName: "Не оперделён",
              mcc: "",
              MNC: ""
            }
            if (this.grouping === 0) {
              record.operatorName = (this.$store.getters.operatorsGroups.find(g => g._id === record.operator_group_id) || {title: "Не определён"}).title
            } else record.operatorName = record.operator.OrgName
            record.mcc = record.operator.mcc

            let country = this.$refs.countrySelect.getCountryByMcc(record.mcc) || this.$refs.countrySelect.getCountryById(record.country_id) || {
              country_name: "",
              country_code: ""
            }
            if (country.country_code !== "" && this.selectedCountry !== "" && String(this.selectedCountry) !== String(country.country_code)) continue

            if (this.operatorGroup !== "" && this.operatorGroup !== record.operator_group_id) continue
            if (this.reportProduct !== "" && this.reportProduct !== record.sms_type) continue
            if (record.draft_traffic_type === "" && record.with_draft) record.draft_traffic_type = "service"

            let row = {
              countryName: country.country_name,
              type: CHANNEL_NAMES[record.sms_type],
              trafficType: TRAFFIC_TYPES[record.draft_traffic_type || ''],
              // mcc: String(country.country_code),
              // mnc: record.operator.mnc,
              senderName: record.draft_traffic_type === "flash" ? '' : record.sms_sender_name,
              operatorName: record.operatorName,
              sent: (parseInt(record.totalMessages) - (parseInt(retval.totalMessages) || 0)),
              avgPrice: (parseFloat(record.rec_unit_price) || parseFloat(record.unit_price) || 0),
              spent: (parseFloat(record.totalRecSum) || parseFloat(record.totalSum) || 0) - (parseFloat(retval.totalSum) || 0),
              __precision: 2,
            }
            row.__precision = Math.max(2, (String(row.avgPrice).split(".")[1] || "").replace(/0+$/, '').length)

            detailData[userId][rateName].push(row)
            addedOpsForThisRate++
            this.detailReportGlobalSummaryRows[0].amount += row.sent
            this.detailReportGlobalSummaryRows[0].spent += row.spent

            generalStatistics[record.sms_type].sent += parseInt(record.totalMessages) - (parseInt(retval.totalMessages) || 0)
            generalStatistics[record.sms_type].spent += ((parseFloat(record.totalRecSum) || parseFloat(record.totalSum) || 0) - (parseFloat(retval.totalSum) || 0))
            // if (record.sms_type === "call") {
            //
            // } else {
            //   generalStatistics.sms.sent += parseInt(record.totalMessages) - (parseInt(retval.totalMessages) || 0)
            //   generalStatistics.sms.spent += (parseFloat(record.totalRecSum) || parseFloat(record.totalSum) || 0) - (parseFloat(retval.totalSum) || 0)
            // }
            generalStatistics.avgPrice += (parseFloat(record.rec_unit_price) || parseFloat(record.unit_price) || 0)
            totalRecords++

          }
          if (addedOpsForThisRate === 0) delete detailData[userId][rateName]
        }
      }
      for (let [userId, userData] of Object.entries(groupedNames)) {
        if (!detailData[userId])
          detailData[userId] = {}

        for (let [rateName, rateData] of Object.entries(userData.byRates)) {

          generalStatistics.names.records.push({
            rateName: rateName,
            amount: rateData[0].totalCount,
            unitPrice: Number(rateData[0].unit_price)
          })
          this.detailReportNamesTableData.push({
            __rate_name_row: true,
            rateName: rateName
          })
          let row = {
            amount: rateData[0].totalCount,
            unitPrice: Number(rateData[0].unit_price),
            spent: parseFloat(rateData[0].totalSum)
          }
          this.detailReportNamesTableData.push(row)
          this.detailReportGlobalSummaryRows[1].amount += row.amount
          this.detailReportGlobalSummaryRows[1].spent += row.spent
          generalStatistics.names.spent += Number(rateData[0].totalSum)
          generalStatistics.names.totalNames += Number(rateData[0].totalCount)

        }
      }
      // console.log(groupedTemplates)
      for (let [userId, userData] of Object.entries(groupedTemplates)) {
        for (let [operId, operRows] of Object.entries(userData.byOperator)) {
          for (let row of operRows) {
            this.detailReportGlobalSummaryRows[2].amount += Number(row.totalCount)
            this.detailReportGlobalSummaryRows[2].spent += Number(row.totalSum)
            generalStatistics.templates.spent += Number(row.totalSum)
            generalStatistics.templates.totalTemplates += Number(row.totalCount)
          }

        }
      }

      for (let [userId, userData] of Object.entries(groupedPrepaidPackages)) {
        for (let [operId, operRows] of Object.entries(userData.byOperator)) {
          for (let row of operRows) {
            this.detailReportGlobalSummaryRows[3].amount += Number(row.totalCount)
            this.detailReportGlobalSummaryRows[3].spent += Number(row.totalSum)
            generalStatistics.prepaidPacks.spent += Number(row.totalSum)
            generalStatistics.prepaidPacks.totalPacks += Number(row.totalCount)
          }

        }
      }

      for (let [userId, userData] of Object.entries(groupedLicense)) {
        this.detailReportGlobalSummaryRows[4].spent += Number(userData) || 0
      }
      for (let [userId, rowsByRates] of Object.entries(detailData)) {
        if (!Object.keys(rowsByRates).length) delete detailData[userId]
        // detailData[userId] = this.deduplicateDetailRows(rows)
      }

      let detailDataSorted = Object.keys(detailData).sort((k1, k2) => {
        return Number(k1.split(".")[1] || 0) - Number(k2.split(".")[1] || 0)
      }).reduce((obj, key) => {
        obj[key] = detailData[key];
        return obj;
      }, {});
      let visibleIds = Object.keys(detailDataSorted)
      if (!visibleIds.length) this.visibleUserId = ""
      this.visibleUserId = visibleIds[0]

      generalStatistics.avgPrice /= totalRecords
      this.commonReportTableData = [
        {type: "Сообщения", sent: generalStatistics.sms.sent, total: generalStatistics.sms.spent, _type: 0},
        {type: "Звонки", sent: generalStatistics.call.sent, total: generalStatistics.call.spent, _type: 1},
        {type: "VK/OK", sent: generalStatistics.vk.sent, total: generalStatistics.vk.spent, _type: 1},
        {type: "Telegram", sent: generalStatistics.telegram.sent, total: generalStatistics.telegram.spent, _type: 1},
        {type: "SIM PUSH", sent: generalStatistics.push.sent, total: generalStatistics.push.spent, _type: 1},
        // {type: "Watsapp", sent: generalStatistics.whatsapp.sent, total: generalStatistics.whatsapp.spent, _type: 1},
        {type: "Подписи", records: generalStatistics.names.records, total: generalStatistics.names.spent, _type: 2},
        {
          type: "Шаблоны СМС",
          records: generalStatistics.templates.records,
          total: generalStatistics.templates.spent,
          sent: generalStatistics.templates.totalTemplates,
          _type: 1,
          noAverage: true
        },
        {type: "Предоплаченные пакеты СМС", total: (generalStatistics.prepaidPacks.spent || 0), _type: 1, sent: generalStatistics.prepaidPacks.totalPacks || 0, noAverage: true},
        {type: "Лицензионные списания", total: (generalStatistics.license.total || 0), justAmount: true},
      ]

      this.generalStatistics = generalStatistics
      if (this.visibleUserId) {
        if (__report_type === "detailed") {
          if (Object.keys(detailDataSorted).length) this.detailReportTableData = detailDataSorted[Object.keys(detailDataSorted)[0]]
          else this.detailReportTableData = {}
        } else this.detailReportTableData = detailDataSorted
      } else this.detailReportTableData = {}//__report_type === 1 ? [] : {}
    },
    getHeaderMonth() {
      return this.$refs.timeSearch.getDateTimeFilter().from.locale("ru-RU").format("MMMM YYYY")
    },
    async getReport() {
      this.reportReady = false
      this.reportLoading = true
      let dateFilter = this.$refs.timeSearch.getDateTimeFilter()
      this.detailHeaderMonth = this.getHeaderMonth()
      this.detailReportNamesTableData = []
      this.detailReportTableData = {}//this.reportType === 1 ? [] : {}
      let rpt = this.reportType
      this.reportTypeStatic = rpt //Number(rpt)
      this.groupingStatic = Number(this.grouping)
      let posting = this.mutateParams({
        month: dateFilter.from.format("DD.MM.YYYY"),
        country: this.country,
        grouping: this.grouping,
        operatorGroup: this.operatorGroup,
        operator: this.operator,
        reportType: this.reportType
      })
      try {
        let resp = await this.axios.post(this.getReportUrl, posting)
        let {sms, retval, names, license, templates, managers, prepaidPacks} = resp.data
        let groupedResult = this.groupResultRowsByUser(sms, retval, names, license, templates, prepaidPacks)
        try {
          this.generateReportData(groupedResult, rpt)
        } catch (e) {
          console.log(e)
        }
        // await this.$nextTick()
        this.reportReady = true
        this.reportLoading = false
        this.visibleReportType = rpt
      } catch {}
    },
    downloadReport() {
      this.reportDownloading = true
      let rows = []
      let injectRateName = ([rateName, rateRows]) => {
        return rateRows.map(r => {
          r.rateName = rateName
          return r
        }).sort((r1, r2) => r1.senderName.localeCompare(r2.senderName))
      }
      if (this.reportTypeStatic === "detailed") rows = Object.entries(this.deduplicateDetailRows(this.detailReportTableData)).map(injectRateName).flat()
      if (this.reportTypeStatic === "byUsers") rows = Object.entries(this.detailReportTableData).map(([userId, rateLevelData]) => {
        return Object.entries(this.deduplicateDetailRows(rateLevelData)).map(injectRateName).flat().map(r => {
          r.userId = userId
          return r
        })
      }).flat()
      let csvContent = [
        iconv.encode(
            `${this.reportTypeStatic === 'byUsers' ? 'Пользователь;' : ''}Тариф;Страна;Продукт;Тип трафика;Подпись;Оператор;Кол-во сообщений;Цена;Расходы\n`,
            "win1251"
        ),
        ...rows.map(r => {
          return iconv.encode([
            this.reportTypeStatic === "byUsers" ? r.userId : undefined,
            r.rateName,
            r.countryName,
            r.type,
            r.trafficType,
            r.senderName,
            r.operatorName,
            r.sent,
            this.formatNumber(r.avgPrice, ',', r.__precision),
            this.formatNumber(r.spent, ',', r.__precision)
          ].filter(v => v !== undefined).join(";") + "\n", "win1251")
        })
      ]
      let blob = new Blob(csvContent, {type: 'text/csv'});

      let a = document.createElement('a');
      a.download = `Детализация расходов за ${this.getHeaderMonth()}.csv`;
      a.href = URL.createObjectURL(blob);
      a.click();
      this.reportDownloading = false
    }
  },
  data() {
    return {
      reportLoading: false,
      reportReady: false,
      detailHeaderMonth: "",
      commonReportTableData: [],
      detailReportTableData: {},
      detailReportGlobalSummaryRows: [],
      detailReportNamesTableData: [],
      grouping: 0,
      groupingStatic: 0,
      reportType: "simple",
      reportTypeStatic: "simple",
      reportProduct: "",
      visibleReportType: "simple",
      selectedCountry: "",
      operatorGroup: "",
      operator: "",
      operators: [],
      generalStatistics: {call: {}, sms: {}, vk: {}, telegram: {}, push: {}, names: {}},
      userStatistics: {},
      visibleUserId: "",
      reportDownloading: false,
      unwrapBy: [
        "countryName",
        "type",
        "trafficType",
        "senderName",
        "operatorName"
      ]
    }
  }
}

</script>